import React from 'react';
import {
  IconButton,
  Grid,
  MenuItem,
  TextField
} from '@material-ui/core';
import { CancelOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import UniversityFilterContainer from '../../../../containers/admin/universities/UniversityFilterContainer';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  }
}))

const EducationHistoryFields = (props) => {
  const classes = useStyles();

  const handleNestedFieldChange = (event, item) => {
    props.onChange(event, item, 'educationHistory');
  }

  const handleRemoveEducation = (education) => {
    props.onClick(education, 'educationHistory');
  }

    const { id, attributes, _destroy } = props.education;
    const yearOptions = _.range(new Date().getFullYear(), 1949)

    return (
      <React.Fragment>
        {_destroy ? null : (
          <Grid container spacing={3} key={id} className={classes.fieldsRow}>
            <Grid
              item
              md={3}
              xs={12}
            >
              <UniversityFilterContainer nestedFields={true} nestedFieldChange={handleNestedFieldChange} item={props.education} />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <TextField
                select
                fullWidth
                value={attributes.start_year || ''}
                name='start_year'
                onChange={(event) => handleNestedFieldChange(event, props.education)}
                label='Start Year'
                variant='outlined'
              >
                {yearOptions.map((year) => <MenuItem key={`start_year-${year}`} value={year}>{year}</MenuItem>)}
              </TextField>
            </Grid>

            <Grid
              item
              md={3}
              xs={12}
            >
              <TextField
                select
                fullWidth
                value={attributes.end_year || ''}
                name='end_year'
                onChange={(event) => handleNestedFieldChange(event, props.education)}
                label='End Year'
                variant='outlined'
              >
                {yearOptions.map((year) => <MenuItem key={`end_year-${year}`} value={year}>{year}</MenuItem>)}
              </TextField>
            </Grid>

            <Grid
              item
              md={3}
              xs={12}
            >
              <IconButton
                color="primary"
                variant="contained"
                onClick={(event) => handleRemoveEducation(props.education)}
              >
                <CancelOutlined />
              </IconButton>

            </Grid>
          </Grid>
        )}
      </React.Fragment>
    )
}

export default EducationHistoryFields;
